import { Box, Container, Typography } from "@mui/material";
import * as React from "react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

type PromoBannerProps = {
  isSubscribed?: boolean;
  promoText?: string;
};

const PromoBanner: React.FC<PromoBannerProps> = ({
  isSubscribed = false,
  promoText
}) => {
  const { t } = useTranslation();

  if (isSubscribed) return null; // no mostrar si está suscrito

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#BFDFFF",
        display: "flex",
        justifyContent: "center",
        borderTop: "1px solid rgba(0,0,0,0.06)",
        opacity: 1,
        backgroundImage: "none"
      }}
    >
      <Container
        maxWidth="xl"
        sx={{ display: "flex", justifyContent: "center" }}
      >
        <Typography
          sx={{
            py: 1,
            fontWeight: 700,
            color: "#333333",
            textAlign: "center"
          }}
        >
          {promoText || t("promo.banner_text")}
        </Typography>
      </Container>
    </Box>
  );
};

export default memo(PromoBanner);
